import React from 'react';
import { Reveal } from './Reveal';
import { QuoteIcon, StarIcon } from './icons/Icons';
const testimonials = [{
  quote: 'Llevaba 2 años durmiendo con 3 almohadas para no ahogarme. A la semana del método ya dormía normal. No lo podía creer.',
  name: 'María Elena R.',
  details: '47 años · Guadalajara',
  initials: 'ME'
}, {
  quote: 'Lo mejor: volví a comer en las reuniones familiares. Ya no me escondo.',
  name: 'Carmen T.',
  details: '42 años · Ciudad de México',
  initials: 'CT'
}, {
  quote: 'Gasté más de $400 en endoscopias, gastroenterólogos y pastillas que solo me servían por unas horas. Ya había perdido la esperanza. Empecé el método sin muchas expectativas y al tercer día el ardor había bajado como un 70%. Lo que más me sorprendió es que la solución estaba en mi cocina todo este tiempo y nadie me lo dijo.',
  name: 'Rosa María Contreras',
  details: '51 años · Monterrey',
  initials: 'RC'
}, {
  quote: 'Tengo 34 años y pensé que la gastritis era “cosa de viejos”. Vivía con reflujo después de cada comida y tomando Omeprazol como si fueran dulces. En 2 semanas dejé las pastillas por completo. Lo mejor fue la guía de restaurantes: volví a salir con mis amigas sin miedo a terminar la noche con dolor.',
  name: 'Daniela Fuentes',
  details: '34 años · Bogotá',
  initials: 'DF'
}, {
  quote: 'Soy mamá de 3 y trabajo, no tengo tiempo para dietas complicadas. Pensé que este método sería otra cosa imposible de seguir. Pero las recetas me toman 10 minutos y uso lo que ya compro. En menos de un mes pasé de despertarme 2 o 3 veces por el ardor a dormir de corrido toda la noche. Volví a sentirme yo misma.',
  name: 'Patricia Jiménez',
  details: '39 años · Miami',
  initials: 'PJ'
}];
export function Testimonials() {
  return <section className="w-full bg-[#f7f4ec] py-16 sm:py-24" data-id="element-410" data-mp="1iuiga58dcp92">
      <div className="mx-auto max-w-5xl px-5" data-id="element-411" data-mp="1nlqs17x68mpe">
        <Reveal data-id="element-412" data-mp="1nnla8eh260ps">
          <p className="text-center text-xs font-extrabold uppercase tracking-[0.18em] text-[#698b68]" data-id="element-413" data-mp="1no3iyakwq7el">Prueba social</p>
          <h2 className="mt-3 text-center font-display text-3xl font-black text-[#29312c] sm:text-4xl" data-id="element-414" data-mp="1siwewlub029d">Mujeres que recuperaron sus noches y su mesa</h2>
        </Reveal>
        <div className="mx-auto mt-10 grid max-w-4xl gap-6 md:grid-cols-2" data-id="element-415" data-mp="1ofhod18qo3ho">
          {testimonials.map((testimonial, index) => <Reveal key={testimonial.name} delay={index * 0.08} data-id="element-416" data-mp="1ej4xsc8hq5r5" data-mpi={index}>
              <figure className="flex h-full flex-col rounded-3xl border border-[#698b68]/12 bg-white p-6 shadow-sm sm:p-7" data-id="element-417" data-mp="1ekg007maf5g5">
                <QuoteIcon className="h-9 w-9 text-[#698b68]/30" data-id="element-418" data-mp="14tbk95osfgk9" />
                <div className="mt-2 flex text-[#d99535]" aria-label="5 de 5 estrellas" data-id="element-419" data-mp="14tlb0vhnprr0">
                  {Array.from({
                length: 5
              }).map((_, star) => <StarIcon key={star} className="h-4 w-4" data-id="element-420" data-mp="vsnf70hdgqji" data-mpi={star} />)}
                </div>
                <blockquote className="mt-4 flex-1 text-lg leading-relaxed text-[#334039]" data-id="element-421" data-mp="vuhr5pao18bg">“{testimonial.quote}”</blockquote>
                <figcaption className="mt-6 flex items-center gap-3 border-t border-[#698b68]/12 pt-4" data-id="element-422" data-mp="32h5w28exotkr">
                  <span className="flex h-11 w-11 items-center justify-center rounded-full bg-[#698b68] font-display text-sm font-black text-white" data-id="element-423" data-mp="37fh7gnkvnc53">{testimonial.initials}</span>
                  <span data-id="element-424" data-mp="3ggoto7a4cmit"><strong className="block font-display text-[#29312c]" data-id="element-425" data-mp="3ggorc0mncafn">{testimonial.name}</strong><span className="text-sm text-[#647067]" data-id="element-426" data-mp="3gekpdo8b5li0">{testimonial.details}</span></span>
                </figcaption>
              </figure>
            </Reveal>)}
        </div>
        <p className="mx-auto mt-6 max-w-2xl text-center text-xs leading-relaxed text-[#7a837c]" data-id="element-427" data-mp="2opr256jhn7yx">Los testimonios deben corresponder a experiencias reales. Los resultados individuales pueden variar.</p>
      </div>
    </section>;
}